// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"00d10432","395":"00d64814","396":"2d20a9f5","409":"5b223f15","521":"6b32b6b9","599":"dbad4208","966":"b81b5a09"}[chunkId] + ".chunk.js";
};